@if (!isSlideOverRoute()) {
  <router-outlet />
} @else {
  <mat-sidenav-container class="kh-side-sheet-container">
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>

    <mat-sidenav
      #slideOver
      mode="over"
      position="end"
      [opened]="slideOverIsOpen()"
      role="region"
      disableClose
      class="kh-slideover"
      [class]="'kh-slideover--' + slideOverWidth()"
      [class.kh-slideover--scheme-light]="slideOverColorScheme() === 'light'"
      [class.kh-slideover--scheme-dark]="slideOverColorScheme() === 'dark'"
      (closed)="onSlideOverClosed()"
    >
      <router-outlet name="slideOver" (activate)="forceOpenSlideOver()">
      </router-outlet>
    </mat-sidenav>
  </mat-sidenav-container>
}
